import * as React from "react";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { PoshSelectCheckboxListItem } from "../../misc/components/PoshSelectListItem";
import { Link, useHistory } from "react-router-dom";
import { SessionTypes } from "../../misc/api/ApiSessionTypes";
import { faDiary, faFvc, faSvc, faEcg, faPcf, faBloodPressure } from "@vitalograph/web-ui";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

interface SessionTypeSelectionProps {
    selectedItem: string;
    onSelect: (id: SessionTypes, multiSelectEnabled: boolean) => void;
    onWizardClose: () => void;
}

export const SessionTypeSelection = ({ selectedItem, onSelect, onWizardClose }: SessionTypeSelectionProps) => {
    const [multipleRecordingsEnabled, setMultipleRecordingsEnabled] = React.useState<boolean>(true);
    const { study, sessionTypes } = useCurrentStudyConfigurationContext();
    const history = useHistory();
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getMultipleSelectionEnabled = async () => {
            const multipleRecordingsEnabledResult = await legacyClient.getSettingsHelper("Vitalograph.WebPortal.Data.Settings.Cough.MultipleRecordingsEnabledSetting", study.id);
            if (multipleRecordingsEnabledResult.Data[0]?.Value !== undefined) {
                setMultipleRecordingsEnabled(multipleRecordingsEnabledResult.Data[0]?.Value === 'True');
            }
        }

        getMultipleSelectionEnabled();
    }, [study.id]);

    const onChange = (id: SessionTypes) => {
        onSelect(id, multipleRecordingsEnabled);
        history.push("/Visit");
    }

    const sessionTypeIcon = (type: SessionTypes) => {
        switch (type) {
            case SessionTypes.Fvc:
                return faFvc;
            case SessionTypes.Svc:
                return faSvc;
            case SessionTypes.Pcf:
                return faPcf;
            case SessionTypes.Ecg:
                return faEcg;
            case SessionTypes.BloodPressure:
                return faBloodPressure;
            case SessionTypes.EDiary:
                return faDiary;
            default:
                return faCircle;
        }
    }

    return (
        <>
            <div className="modal-body">
                <h2 className="text-primary">Session Type</h2>
                <p className="text-muted">Select a session type to start</p>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="posh-select">
                            {sessionTypes.map(st =>
                                <PoshSelectCheckboxListItem key={`SessionType${st.Id}`} id={st.Id} title={st.Name} icon={sessionTypeIcon(st.Id)} isChecked={selectedItem === st.Id} onChange={() => onChange(st.Id)} />
                            )}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary btn-outline" onClick={onWizardClose}>Close</button>
            </div>
        </>
    );
}
